import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import {withRouter} from 'react-router-dom';
import {printInNewTab} from '../../../../utilities/print';
import {parsePrintXML} from '../../../../utilities/xml';
import {SHELL_URL} from '../../../../config';
import {isEmpty} from '../../../../utilities/validation';


const getDataFromNode = function(node) {
    const keys = ['id', 'title', 'x', 'y', 'src', 'visible', 'enabled', 'zIndex', 'bgalpha'];
    const props = filterNodeProperties(node, keys, {});
    props.enabled = props.enabled !== '0';
    props.visible = props.visible !== '0';
    return props;
};

const getActionNode = function (node) {
    const actionNode = node.childNamed('action_node') || null;
    if (!actionNode) {
        return {};
    }
    /**
     * "Command" is actually a local file path.
     * "Type" is usually a type of action such as "print"
     **/
    let actionNodeProperties = filterNodeProperties(actionNode, ['command', 'type', 'parms'], {});

    // If the actionNode has a print property, then we assume that the val is the printTemplate
    if(actionNodeProperties.type === 'print'){
        actionNodeProperties.printTemplate = actionNode.val;
    }
    return actionNodeProperties;
};

class ActionButtonNode extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node),
            height: 0,
            hovered: false,
            clicked: false,
            ...getActionNode(props.node),
        };

        this.actionClick = this.actionClick.bind(this);
        this.onButtonMouseOver = this.onButtonMouseOver.bind(this);
        this.onButtonMouseOut = this.onButtonMouseOut.bind(this);
        this.onButtonMouseDown = this.onButtonMouseDown.bind(this);
        this.onButtonMouseUp = this.onButtonMouseUp.bind(this);
        this.audioEnded = this.audioEnded.bind(this);
        this.printEvent = this.printEvent.bind(this);
        this.showButton = this.showButton.bind(this);
    }

    componentDidMount() {
        document.addEventListener('jre-audio-ended', this.audioEnded);
        document.addEventListener('jre-print', this.printEvent);
        document.addEventListener('jre-btn-show', this.showButton);
    }

    componentWillUnmount() {
        document.removeEventListener('jre-audio-ended', this.audioEnded);
        document.removeEventListener('jre-print', this.printEvent);
        document.removeEventListener('jre-btn-show', this.showButton);
    }

    printEvent(e) {
        const {type = ''} = this.state;
        if (type !== 'print') {
            return;
        }

        // When we have a "Hidden Print Button", we need to fake a click (MO.WTSM.3.0.2 - 124) (MO.ENVI.3.0.1 - 722)
        const isHiddenPrintButton = this.props.node.attr.x === '-1000' && this.props.node.attr.y === '-1000';
        if (isHiddenPrintButton){
            this.actionClick();
        }
    }

    audioEnded() {
        this.setState({enabled: true});
    }

    showButton(e) {
        if (e.detail.target === this.state.id) {
            this.setState({visible: true});
        }
    }

    onImgLoad({target: img}) {
        // This is a sprite image where the image contains 5 other images/buttons.
        this.setState({height: parseInt(img.naturalHeight) / 5});
    }

    styleBackgroundPosition() {
        let {enabled = false, clicked = false, hovered = false, height = 0} = this.state;

        // Since we assume the height of the images will vary, these calculations are done here and not in the CSS file.
        if (!enabled) {
            return `0 -${parseInt(height * 3)}px`;
        } else if (clicked) {
            return `0 -${parseInt(height)}px`;
        } else if (hovered) {
            if(parseInt(height) > 10) {
                return `0 -${parseInt(height) * 2}px`;
            }
            return '0 0';
        } else {
            return '0 0';
        }
    }

    onButtonMouseOver() {
        this.setState({hovered: true});
    }

    onButtonMouseOut() {
        this.setState({hovered: false});
    }

    onButtonMouseDown() {
        this.setState({clicked: true});
    }

    onButtonMouseUp() {
        this.setState({clicked: false});
    }

    actionClick() {
        const {command = '', parms = '', type=''} = this.state;
        let {printTemplate = ''} = this.state;

        if (type === 'print' && !isEmpty(printTemplate)) {
            setTimeout(function() {
                const {studentAnswers = {}} = this.props;
                printTemplate = parsePrintXML(printTemplate, studentAnswers);
                printInNewTab(printTemplate);
            }.bind(this), 350);
        } else if (command) {
            // This will work only if the required security settings are set in the browser.
            /*let wnd = window.open('', '','width=1, height=1,' +
                'scrollbars=no,toolbar=no,menubar=no,location=no,directories=no,status=no');
            wnd.fetch(`${SHELL_URL}${command}&appParams=${parms}`);
            wnd.resizeTo(1, 1);
            /*setTimeout(function() {
                if(!wnd.closed){
                    wnd.close();
                }
            }, 400);*/
            window.open(`${SHELL_URL}${command}&appParams=${parms}`);

        }
    }


    render() {
        const {moduleURL = ''} = this.props;
        let {x = 0, y = 0, src = '', visible = false, enabled = false, height = 0, zIndex = undefined, bgalpha=''} = this.state;

        // Fallback if there is no height set for the image. There should not be any images with a height less than 10px
        height = parseFloat(height) < 10.00 ? 'auto': `${height}px`;

        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            display: visible ? 'block' : 'none',
            background: `url(${moduleURL}/media/${src}) no-repeat`,
            backgroundPosition: this.styleBackgroundPosition(),
            height: height
        };

        if (zIndex !== undefined) {
            divStyle['zIndex'] = zIndex;
        }

        if (bgalpha) {
            // if we need to set opacity, we divide the XML value by 100
            divStyle.opacity = bgalpha === '0' ? 0 : parseInt(bgalpha) / 100;
        }

        let multiClick = () => {
            if (this.props.onClick) {
                this.props.onClick();
                this.actionClick();
            }
            else {
                this.actionClick();
            }
        };

        const buttonElement = (
            <button className="node button-node"
                    style={divStyle}
                    onMouseOut={this.onButtonMouseOut}
                    onMouseUp={this.onButtonMouseUp}
                    onMouseDown={this.onButtonMouseDown}
                    onMouseOver={this.onButtonMouseOver}
                    onClick={multiClick}
                    disabled={enabled === false}>
                {/* This non-visible image element is used to get the height of the image. */}
                <img className="visibility-hidden"
                     onLoad={this.onImgLoad.bind(this)}
                     src={`${moduleURL}/media/${src}`}
                />
            </button>
        );

        return (
            <div className="action-button-node">
                {buttonElement}
            </div>
        );
    }
}

ActionButtonNode.propTypes = {
    node: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return {
        studentAnswers: state.answers.list,
        answers: state.answers
    };
};

const ActionButtonNodeContainer = connect(
    mapStateToProps,
    null
)(ActionButtonNode);

export default withRouter(ActionButtonNodeContainer);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/action-button-node.js